export const en = {
  'onboarding.login.subtitle':
    "ForSport, the ultimate destination for racing and sports betting. Let's sign you back in so you can <Node>start placing bets now!</Node>",
};
